import { render, staticRenderFns } from "./negotiation.vue?vue&type=template&id=be10ba8c&scoped=true&"
import script from "./negotiation.vue?vue&type=script&lang=js&"
export * from "./negotiation.vue?vue&type=script&lang=js&"
import style0 from "./negotiation.vue?vue&type=style&index=0&id=be10ba8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be10ba8c",
  null
  
)

export default component.exports